export default __webpack_public_path__ + "static/media/planeAsset 3.2121e813.svg";